function chunkArray(arr, size) {
  arr = arr.slice();
  const results = [];
  while (arr.length) {
    results.push(arr.splice(0, size || 1));
  }
  return results;
}

module.exports = chunkArray;
